import { Dispatch, SetStateAction, useEffect } from 'react';

import { useNavigateToRoute } from '../../../../../shared/hooks/use-navigate-to-route/use-navigate-to-route.hook';
import { useAppDispatch } from '../../../../../store/hooks';
import { IdFile } from '../../../../shared/models/id-file.model';
import { getBlobFile } from '../../../../shared/thunks/get-blob-file.thunk';
import { mapFileMetadataModelToIdFile } from '../../../../shared/utils/mapping/mapping.utils';
import {
  resetGameForm,
  setGame,
  setGameThumbnail,
  setGameZip,
} from '../../../store/slices/web-game.slice';
import { getWebGameById } from '../../../thunks/get-web-game-by-id.thunk';
import { webGameResponseModelToFormik } from '../../../utils/web-game-response-model-to-formik';

export const usePopulateGameDetails = (
  isOnEdit: boolean,
  setThumbnailFile: Dispatch<SetStateAction<IdFile[] | undefined>>,
  setZipFile: Dispatch<SetStateAction<IdFile[] | undefined>>,
  id?: string
): void => {
  const dispatch = useAppDispatch();
  const navigateBack = useNavigateToRoute('../games');

  useEffect(() => {
    if (isOnEdit && id) {
      (async () => {
        try {
          const data = await dispatch(getWebGameById({ gameId: +id })).unwrap();
          dispatch(setGame(webGameResponseModelToFormik(data)));
          dispatch(
            getBlobFile({
              downloadLink: data.thumbnail.downloadLink,
              id: data.thumbnail.id,
              name: data.thumbnail.name,
            })
          )
            .unwrap()
            .then(result => {
              dispatch(setGameThumbnail(data.thumbnail));
              setThumbnailFile([result]);
            });
          dispatch(setGameZip(data.zip));
          setZipFile([mapFileMetadataModelToIdFile(data.zip)]);
        } catch (_) {
          navigateBack();
        }
      })();
    }

    return () => {
      dispatch(resetGameForm());
    };
  }, [isOnEdit, id]);
};
